@if (!includeTime) {
  <mat-form-field class="w-100">
    @if (label) {
      <mat-label>{{ label }}</mat-label>
    }
    <input matInput
      [matDatepicker]="datePicker"
      [formControl]="dateControl"
      [required]="required"
      [disabled]="disabled"
      (blur)="onBlur()" />
    <mat-datepicker-toggle matSuffix
      [for]="datePicker"></mat-datepicker-toggle>
    <mat-datepicker #datePicker></mat-datepicker>
    @if (hint) {
      <mat-hint>{{ hint }}</mat-hint>
    }
  </mat-form-field>
} @else {
  <div class="d-flex align-items-center gap-2">
    <mat-form-field class="w-100">
      @if (label) {
        <mat-label>{{ label }}</mat-label>
      }
      <input matInput
        [matDatepicker]="dateTimePicker"
        [formControl]="dateControl"
        [required]="required"
        [disabled]="disabled"
        (blur)="onBlur()" />
      <mat-datepicker-toggle matSuffix
        [for]="dateTimePicker"></mat-datepicker-toggle>
      <mat-datepicker #dateTimePicker></mat-datepicker>
      @if (hint) {
        <mat-hint>{{ hint }}</mat-hint>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Orario</mat-label>
      <input matInput
        [matTimepicker]="timePicker"
        [formControl]="dateControl"
        [required]="required"
        [disabled]="disabled"
        (blur)="onBlur()" />
      <mat-timepicker #timePicker />
      <mat-timepicker-toggle [for]="timePicker"
        matSuffix />
    </mat-form-field>
  </div>
}